import {
  GET_APPOINT_NOTIFICATIONS_REQUEST,
  GET_APPOINT_NOTIFICATIONS_SUCCESS,
  GET_APPOINT_NOTIFICATIONS_FAILURE,
  GET_ORDERS_ACHIEVEMENT_REQUEST,
  GET_ORDERS_ACHIEVEMENT_SUCCESS,
  GET_ORDERS_ACHIEVEMENT_FAILURE,
  GET_ORDERS_OVERVIEW_REQUEST,
  GET_ORDERS_OVERVIEW_SUCCESS,
  GET_ORDERS_OVERVIEW_FAILURE,
  GET_CALL_LIST_REQUEST,
  GET_CALL_LIST_SUCCESS,
  GET_CALL_LIST_FAILURE,
  GET_REACTION_LIST_REQUEST,
  GET_REACTION_LIST_SUCCESS,
  GET_REACTION_LIST_FAILURE,
} from "../../constants/ActionTypes";

import { OrdersApi } from "../api/OrdersApi";
import { TIMELINE_STATUS_PER_PAGE } from "../../constants/Constants";
import { TimelineApi } from "../api/TimelineApi";
import { TimelineLabelType } from "../../constants/ComponentTypes";

/***  GET /timeline_status ***/
const getAppointmentNotificationsRequest = (overwrite) => ({
  type: GET_APPOINT_NOTIFICATIONS_REQUEST,
  payload: {
    overwrite: overwrite,
  },
});

const getAppointmentNotificationsSuccess = (statuses, pageInfo, overwrite) => ({
  type: GET_APPOINT_NOTIFICATIONS_SUCCESS,
  payload: {
    statuses: statuses,
    pageInfo: pageInfo,
    overwrite: overwrite,
  },
});

const getAppointmentNotificationsFailure = (error) => ({
  type: GET_APPOINT_NOTIFICATIONS_FAILURE,
  payload: {
    error: error,
  },
});

export function getAppointmentNotifications(data = {}, overwrite) {
  return async (dispatch) => {
    let query = {
      ...data,
    };

    dispatch(getAppointmentNotificationsRequest(overwrite));

    TimelineApi.getTimelineStatus(
      {
        ...query,
        timeline_status: [TimelineLabelType.APPOINTMENT.value],
      },
      dispatch
    )
      .then((response) => {
        dispatch(
          getAppointmentNotificationsSuccess(
            response.data.data,
            response.data.meta,
            overwrite
          )
        );
      })
      .catch((error) => {
        dispatch(getAppointmentNotificationsFailure(error.response));
      });
  };
}

/*** GET /orders/overview ***/
const getOrdersOverviewRequest = () => ({
  type: GET_ORDERS_OVERVIEW_REQUEST,
});

const getOrdersOverviewSuccess = (data) => ({
  type: GET_ORDERS_OVERVIEW_SUCCESS,
  payload: {
    overview: data,
  },
});

const getOrdersOverviewFailure = (error) => ({
  type: GET_ORDERS_OVERVIEW_FAILURE,
  payload: {
    error: error,
  },
});

export function getOrdersOverview(data) {
  return async (dispatch) => {
    dispatch(getOrdersOverviewRequest());

    OrdersApi.getOrdersOverview(data, dispatch)
      .then((response) => {
        dispatch(getOrdersOverviewSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getOrdersOverviewFailure(error.response));
      });
  };
}

/*** GET /orders/overview ***/
const getOrderAchievementRequest = () => ({
  type: GET_ORDERS_ACHIEVEMENT_REQUEST,
});

const getOrderAchievementSuccess = (data) => ({
  type: GET_ORDERS_ACHIEVEMENT_SUCCESS,
  payload: {
    overview: data,
  },
});

const getOrderAchievementFailure = (error) => ({
  type: GET_ORDERS_ACHIEVEMENT_FAILURE,
  payload: {
    error: error,
  },
});

export function getOrderAchievement(data) {
  return async (dispatch) => {
    dispatch(getOrderAchievementRequest());

    OrdersApi.getOrdersOverview(data, dispatch)
      .then((response) => {
        dispatch(getOrderAchievementSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getOrderAchievementFailure(error.response));
      });
  };
}

/***  GET /timeline_status***/
const getCallListRequest = (overwrite) => ({
  type: GET_CALL_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
  },
});

const getCallListSuccess = (statuses, pageInfo, overwrite) => ({
  type: GET_CALL_LIST_SUCCESS,
  payload: {
    statuses: statuses,
    pageInfo: pageInfo,
    overwrite: overwrite,
  },
});

const getCallListFailure = (error) => ({
  type: GET_CALL_LIST_FAILURE,
  payload: {
    error: error,
  },
});

export function getCallList(
  data = { paging: 1, page: 1, per_page: TIMELINE_STATUS_PER_PAGE },
  overwrite = true
) {
  return async (dispatch) => {
    let query = {
      ...data,
    };
    dispatch(getCallListRequest(overwrite));

    TimelineApi.getTimelineStatus(
      {
        ...query,
      },
      dispatch
    )
      .then((response) => {
        dispatch(
          getCallListSuccess(response.data.data, response.data.meta, overwrite)
        );
      })
      .catch((error) => {
        dispatch(getCallListFailure(error.response));
      });
  };
}

/*** GET /timeline_statuses ***/
const getReactionListRequest = (overwrite) => ({
  type: GET_REACTION_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
  },
});

const getReactionListSuccess = (statuses, pageInfo, overwrite) => ({
  type: GET_REACTION_LIST_SUCCESS,
  payload: {
    statuses: statuses,
    pageInfo: pageInfo,
    overwrite: overwrite,
  },
});

const getReactionListFailure = (error) => ({
  type: GET_REACTION_LIST_FAILURE,
  payload: {
    error: error,
  },
});

export function getReactionList(
  data = { paging: 1, page: 1, per_page: TIMELINE_STATUS_PER_PAGE },
  overwrite = true
) {
  return async (dispatch) => {
    let query = {
      ...data,
    };
    dispatch(getReactionListRequest(overwrite));

    TimelineApi.getTimelineStatus(
      {
        ...query,
      },
      dispatch
    )
      .then((response) => {
        dispatch(
          getReactionListSuccess(
            response.data.data,
            response.data.meta,
            overwrite
          )
        );
      })
      .catch((error) => {
        dispatch(getReactionListFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/OrderDashboard.js